import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const fetchData = createAsyncThunk(
    'kitchenProducts/fetchData',
    async (data, { rejectWithValue }) => {
        const api = '/products/searchProductsByKitchen?XDEBUG_SESSION_START=MyVSCode';
    
        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));
    
            if (response.data?.result) {
                const categories = response.data?.data?.search?.categories?.categories || [];
                const categoriesSorting = response.data?.data?.search?.categories?.categoriesSorting || [];
                const products = Array.isArray(response.data?.data?.search?.products) 
                    ? response.data.data.search.products.filter(p => p?.status !== 'deleted')
                    : [];
                
                return {
                    categories,
                    categoriesSorting,
                    products,
                };
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const updateCategorySorting = createAsyncThunk(
    'kitchenProducts/updateCategorySorting',
    async (data, { rejectWithValue }) => {
        const api = '/products/categories/sort/add?XDEBUG_SESSION_START=MyVSCode';
    
        // {"data":{"kitchenId":152005,"sortingCategories":[{"categoryId":1,"sort":1},{"categoryId":2,"sort":2}]}}

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));
    
            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const switchOnProductByKitchen = createAsyncThunk(
    'kitchenProducts/switchOnProductByKitchen',
    async (data, { rejectWithValue }) => {
        const api = '/products/toggleHiding?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));
    
            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const switchOnProductByAdmin = createAsyncThunk(
    'kitchenProducts/switchOnProductByAdmin',
    async (data, { rejectWithValue }) => {
        const api = '/products/toggleBlocking?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));
    
            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const removeProductImage = createAsyncThunk(
    'kitchenProducts/removeProductImage',
    async (data, { rejectWithValue }) => {
        const api = '/products/deleteImg?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));
    
            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const getProductAnalytics = createAsyncThunk(
    'kitchenProducts/getProductAnalytics',
    async (data, { rejectWithValue }) => {
        const api = '/products/getProductAnalytics?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));
    
            if (response.data.result) {
                return response.data.data.analytics;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const getProductReviewsByProductId = createAsyncThunk(
    'kitchenProducts/getProductReviewsByProductId',
    async (data, { rejectWithValue }) => {
        const api = '/products/getReviewsByProductId?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));
    
            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const selectFilteredCategories = (state) => {
    const { categories = [], products = [], filters = {} } = state?.kitchenProducts || {};

    if (!Array.isArray(categories) || !Array.isArray(products)) {
        return [];
    }

    return categories.map(category => {
        // Все продукты категории (без фильтрации)
        const allCategoryProducts = products.filter(product => product.categoryId === category.id);
        
        // Отфильтрованные продукты
        const filteredProducts = products.filter(product => {
            const matchesCategory = product.categoryId === category.id;

            const matchesSearch = filters.searchQuery
                ? product.name?.toLowerCase().includes(filters.searchQuery.toLowerCase()) ||
                  product.description?.toLowerCase().includes(filters.searchQuery.toLowerCase())
                : true;

            const matchesMinPrice = filters.minPrice !== null
                ? product.price >= filters.minPrice
                : true;

            const matchesMaxPrice = filters.maxPrice !== null
                ? product.price <= filters.maxPrice
                : true;

            const matchesModeration = filters.showModeration
                ? true
                : !product.moderation;

            const matchesDisabled = filters.showDisabled
                ? true
                : product.status !== 'hidden';

            const matchesBlocked = filters.showBlocked
                ? true
                : product.status !== 'blocked';

            return matchesCategory && matchesSearch && matchesMinPrice && matchesMaxPrice && matchesModeration && matchesDisabled && matchesBlocked;
        });

        return {
            ...category,
            // Отфильтрованные данные
            productsCount: filteredProducts.length,
            isModerationRejectedCount: filteredProducts.filter(p => p.moderation && p.moderation.status === 'rejected').length,
            isModerationProductCount: filteredProducts.filter(p => p.moderation && p.moderation.status === 'pending').length,
            isCheckProductCount: filteredProducts.filter(p => !p.moderation && p.status !== 'deleted').length,
            isDeletedProductCount: filteredProducts.filter(p => p.status === 'deleted').length,
            // Начальные данные (без фильтрации)
            totalProductsCount: allCategoryProducts.length,
            totalModerationRejectedCount: allCategoryProducts.filter(p => p.moderation && p.moderation.status === 'rejected').length,
            totalModerationProductCount: allCategoryProducts.filter(p => p.moderation && p.moderation.status === 'pending').length,
            totalCheckProductCount: allCategoryProducts.filter(p => !p.moderation && p.status !== 'deleted').length,
            totalDisabledProductCount: allCategoryProducts.filter(p => p.status === 'hidden').length,
            totalBlockedProductCount: allCategoryProducts.filter(p => p.status === 'blocked').length,
            totalDeletedProductCount: allCategoryProducts.filter(p => p.status === 'deleted').length,
        };
    });
};

export const selectFilteredProducts = (state) => {
    const { products = [], currentCategory = null, filters = {} } = state?.kitchenProducts || {};
    
    if (!Array.isArray(products)) {
        return [];
    }
  
    return products.filter(product => {
        const matchesCategory = currentCategory !== null ? product.categoryId === currentCategory : true;

        const matchesSearch = filters.searchQuery
            ? product.name?.toLowerCase().includes(filters.searchQuery.toLowerCase()) ||
              product.description?.toLowerCase().includes(filters.searchQuery.toLowerCase())
            : true;

        const matchesMinPrice = filters.minPrice !== null
            ? product.price >= filters.minPrice
            : true;

        const matchesMaxPrice = filters.maxPrice !== null
            ? product.price <= filters.maxPrice
            : true;

        const matchesModeration = filters.showModeration
            ? true
            : !product.moderation;

        const matchesDisabled = filters.showDisabled
            ? true
            : product.status !== 'hidden';

        const matchesBlocked = filters.showBlocked
            ? true
            : product.status !== 'blocked';

        return matchesCategory && matchesSearch && matchesMinPrice && matchesMaxPrice && matchesModeration && matchesDisabled && matchesBlocked;
    });
};

// Загружаем фильтры из localStorage
const loadFiltersFromStorage = () => {
    const defaultFilters = {
        searchQuery: '',
        minPrice: null,
        maxPrice: null,
        showModeration: true,
        showDisabled: true,
        showBlocked: true,
    };
    
    try {
        const savedFilters = localStorage.getItem('kitchenProductsFilters');
        if (savedFilters) {
            const parsed = JSON.parse(savedFilters);
            // Загружаем только show* ключи из localStorage
            return {
                ...defaultFilters,
                showModeration: parsed.showModeration ?? true,
                showDisabled: parsed.showDisabled ?? true,
                showBlocked: parsed.showBlocked ?? true,
            };
        }
    } catch (error) {
        console.error('Ошибка при загрузке фильтров из localStorage:', error);
    }
    return defaultFilters;
};

const initialState = {
    fetchDataStatus: null,
    updateCategorySortingStatus: null,
    switchOnProductByKitchenStatus: null,
    switchOnProductByAdminStatus: null,

    filters: loadFiltersFromStorage(),

    categories: [],
    currentCategory: null,
    products: [],
    currentProduct: null,

    drawerShow: false,
    previewImage: null,

    getProductAnalyticsStatus: null,
    productAnalytics: null,
    productRatings: null,
};

const kitchenProductsSlice = createSlice({
    name: 'kitchenProducts',
    initialState,
    extraReducers: (builder) => {
        builder
            // Fetch Data
            .addCase(fetchData.pending, (state) => {
                state.fetchDataStatus = 'pending';
            })
            .addCase(fetchData.fulfilled, (state, action) => {
                state.fetchDataStatus = 'fulfilled';
                const { categories = [], categoriesSorting = [], products = [] } = action.payload || {};

                const sortByCategoryId = {};
                if (Array.isArray(categoriesSorting)) {
                    categoriesSorting.forEach(item => {
                        if (item?.categoryId !== undefined && item?.sort !== undefined) {
                            sortByCategoryId[item.categoryId] = item.sort;
                        }
                    });
                }
            
                const categoriesWithSortAndCounts = (Array.isArray(categories) ? categories : []).map(category => {
                    if (!category?.id) return null;
                    const filteredProducts = (Array.isArray(products) ? products : []).filter(product => product?.categoryId === category.id);

                    return {
                        ...category,
                        sort: sortByCategoryId[category.id] || 0, // если нет сортировки, ставим 0
                        productsCount: filteredProducts.length,
                        isModerationRejectedCount: filteredProducts.filter(p => p?.moderation && p.moderation.status === 'rejected').length,
                        isModerationProductCount: filteredProducts.filter(p => p?.moderation && p.moderation.status === 'pending').length,
                        isCheckProductCount: filteredProducts.filter(p => !p?.moderation && p?.status !== 'deleted').length,
                        isDeletedProductCount: filteredProducts.filter(p => p?.status === 'deleted').length,
                    };
                }).filter(Boolean);
            
                state.categories = categoriesWithSortAndCounts;
                state.currentCategory = categoriesWithSortAndCounts.find(cat => cat.sort === 1)?.id || 1;
                state.products = products;
            })            
            .addCase(fetchData.rejected, (state) => {
                state.fetchDataStatus = 'rejected';
            })
            // Update Category Sorting
            .addCase(updateCategorySorting.pending, (state, action) => {
                state.updateCategorySortingStatus = 'pending';
                const sorting = action?.meta?.arg?.sortingCategories;
                if (!Array.isArray(sorting)) return;
                
                const categoryMap = new Map((Array.isArray(state.categories) ? state.categories : []).map(cat => [cat?.id, cat]));

                state.categories = sorting
                    .map(({ categoryId, sort }) => {
                        const category = categoryMap.get(categoryId);
                        if (category) {
                            category.sort = sort;
                        }
                        return category;
                    })
                    .filter(Boolean);
            })
            .addCase(updateCategorySorting.fulfilled, (state) => {
                state.updateCategorySortingStatus = 'fulfilled';
            })
            .addCase(updateCategorySorting.rejected, (state) => {
                state.updateCategorySortingStatus = 'rejected';
            })
            // SwitchOn Product By Kitchen
            .addCase(switchOnProductByKitchen.pending, (state) => {
                state.switchOnProductByKitchenStatus = 'pending';
            })
            .addCase(switchOnProductByKitchen.fulfilled, (state, action) => {
                state.switchOnProductByKitchenStatus = 'fulfilled';
                console.log('action', action);
                const productId = action?.meta?.arg?.productId;
                if (productId === undefined) return;
                
                state.products = (Array.isArray(state.products) ? state.products : []).map((product) => {
                    if (product?.id === productId) {
                        console.log(product);
                        return {
                            ...product,
                            status: product.status === 'hidden' ? 'active' : 'hidden',
                        };
                    }
                    return product;
                });
            })
            .addCase(switchOnProductByKitchen.rejected, (state) => {
                state.switchOnProductByKitchenStatus = 'rejected';
            })
            // SwitchOn Product By Admin
            .addCase(switchOnProductByAdmin.pending, (state) => {
                state.switchOnProductByAdminStatus = 'pending';
            })
            .addCase(switchOnProductByAdmin.fulfilled, (state, action) => {
                state.switchOnProductByAdminStatus = 'fulfilled';
                console.log('action', action);
                const productId = action?.meta?.arg?.productId;
                if (productId === undefined) return;
                
                state.products = (Array.isArray(state.products) ? state.products : []).map((product) => {
                    if (product?.id === productId) {
                        console.log(product);
                        return {
                            ...product,
                            status: product.status === 'blocked' ? 'active' : 'blocked',
                        };
                    }
                    return product;
                });
            })
            .addCase(switchOnProductByAdmin.rejected, (state) => {
                state.switchOnProductByAdminStatus = 'rejected';
            })
            // getProductAnalytics
            .addCase(getProductAnalytics.pending, (state) => {
                state.getProductAnalyticsStatus = 'pending';
            })
            .addCase(getProductAnalytics.fulfilled, (state, action) => {
                state.getProductAnalyticsStatus = 'fulfilled';
                state.productAnalytics = action.payload?.analytics || null;
                state.productRatings = action.payload?.products || null;
            })
            .addCase(getProductAnalytics.rejected, (state) => {
                state.getProductAnalyticsStatus = 'rejected';
            })
            // PURGE
            .addCase(PURGE, () => {
                return initialState;
            });
    },
    reducers: {
        setFilters: (state, action) => {
            if (action?.payload) {
                state.filters = action.payload;
                // Сохраняем только show* ключи в localStorage
                const filtersToSave = {
                    showModeration: action.payload.showModeration ?? true,
                    showDisabled: action.payload.showDisabled ?? true,
                    showBlocked: action.payload.showBlocked ?? true,
                };
                try {
                    localStorage.setItem('kitchenProductsFilters', JSON.stringify(filtersToSave));
                } catch (error) {
                    console.error('Ошибка при сохранении фильтров в localStorage:', error);
                }
            }
        },
        clearFilters: (state) => {
            state.filters = {
                searchQuery: '',
                minPrice: null,
                maxPrice: null,
                showModeration: true,
                showDisabled: true,
                showBlocked: true,
            };
            // Очищаем фильтры в localStorage
            localStorage.removeItem('kitchenProductsFilters');
        },
        setCurrentCategory: (state, action) => {
            state.currentCategory = action.payload;
        },
        setCurrentProduct: (state, action) => {
            state.currentProduct = action.payload;
        },
        updateProducts: (state, action) => {
            if (!action?.payload?.id) return;
            
            const existingProductIndex = (Array.isArray(state.products) ? state.products : []).findIndex(
                (product) => product?.id === action.payload.id
            );
        
            if (existingProductIndex !== -1) {
                // ID найден, обновляем поле moderation
                state.products = state.products.map((product, index) =>
                    index === existingProductIndex
                    ? { ...product, moderation: action.payload.moderation }
                    : product
                );
            } else {
                // ID не найден, добавляем новый объект
                state.products = [...state.products, action.payload];
            }
        },
        removeProductModeration: (state, action) => {
            if (action?.payload === undefined) return;
            
            const existingProductIndex = (Array.isArray(state.products) ? state.products : []).findIndex(
                (product) => product?.moderation?.id === action.payload
            );
        
            if (existingProductIndex !== -1) {
                // ID найден, обновляем поле moderation
                state.products = state.products.map((product, index) =>
                    index === existingProductIndex && product.status === 'new'
                    ? { ...product, status: 'deleted', moderation: null }
                    : index === existingProductIndex
                    ? { ...product, moderation: null }
                    :product
                );
            }
        },
        setDrawerShow: (state, action) => {
            state.drawerShow = action.payload;
        },
        setPreviewImage: (state, action) => {
            state.previewImage = action.payload;
        },
    },
});

export const {
    setFilters,
    clearFilters,
    setCurrentCategory,
    setCurrentProduct,
    updateProducts,
    removeProductModeration,
    setDrawerShow,
    setPreviewImage,
} = kitchenProductsSlice.actions;

export default kitchenProductsSlice.reducer;
